import { ASSET_TOKENS_PAIRS, SUPPORTED_TOKENS } from "./constants";
import { isSupportedNetwork } from "./resolver";

function getTokenInfo(chainId, tokenSymbol) {
  // {chainId, description, erc20Symbol, erc20Address, tokenxSymbol, tokenxAddress}
  return SUPPORTED_TOKENS[chainId][tokenSymbol];
}

function getSupportedTokens(chainId) {
  // return the supported tokens for the given network
  // used by Holdings component to list supported assets
  if (chainId in SUPPORTED_TOKENS) {
    let supportedTokensDict = SUPPORTED_TOKENS[chainId];

    return Object.values(supportedTokensDict);
  }

  return [];
}

function getSupportedToken(chainId, tokenxSymbol) {
  if (chainId in SUPPORTED_TOKENS && tokenxSymbol in SUPPORTED_TOKENS[chainId])
    return SUPPORTED_TOKENS[chainId][tokenxSymbol];
  else return {};
}

function getTargetTokens(chainId) {
  // returns all available target tokens for the investor
  let targetTokens = [];

  if (isSupportedNetwork(chainId)) {
    const atPairs = Object.keys(ASSET_TOKENS_PAIRS[chainId]);

    for (let idx in atPairs) {
      let assetSymbol = atPairs[idx];
      targetTokens.push(getTokenInfo(chainId, assetSymbol));
    }
  }

  return targetTokens;
}

function getSourceTokens(chainId, targetTokenSymbol) {
  // returns all available tokens for the selected target asset
  const sourceTokens = [];

  if (isSupportedNetwork(chainId)) {
    const chainAssets = ASSET_TOKENS_PAIRS[chainId];
    if (targetTokenSymbol in chainAssets) {
      const atPairs = Object.keys(chainAssets[targetTokenSymbol]);

      for (let idx in atPairs) {
        let assetSymbol = atPairs[idx];
        sourceTokens.push(getTokenInfo(chainId, assetSymbol));
      }
    }
  }

  return sourceTokens;
}

function getTokenAddress(chainId, tokenSymbol) {
  try {
    // TODO: ugh, kinda inefficient
    const supportedTokens = Object.values(SUPPORTED_TOKENS[chainId]);

    for (let idx in supportedTokens) {
      let token = supportedTokens[idx];
      if (tokenSymbol === token.erc20Symbol) {
        return token.erc20Address;
      } else if (tokenSymbol === token.tokenxSymbol) {
        return token.tokenxAddress;
      }
    }
  } catch {
    // TODO: there are some cases where the page renders even without being connected
    // e.g. brave seems to use the cache or something
    return "";
  }
}

function getAmountConfiguration(chainId, tokenSymbol, length) {
  const tokenInfo = SUPPORTED_TOKENS[chainId][tokenSymbol];
  if (length === 0) return tokenInfo.foreverLength;
  else return tokenInfo.fixedLength;
}

export {
  getSupportedTokens,
  getSupportedToken,
  getTokenInfo,
  getTokenAddress,
  getSourceTokens,
  getTargetTokens,
  getAmountConfiguration,
};
